<template>
    <div class="contentElement__back">
        <h3 class="contentElement__backTitle">
            {{ title }}
        </h3>
        <p class="contentElement__backIntro">
            {{ features }}
        </p>
        <Ticker :side="'back'" />
        <div class="contentElement__actions">
            <a
                v-for="cta in ctas"
                :key="cta.text"
                :href="cta.url"
                class="cta contentElement__cta"
            >
                {{ cta.text }}
            </a>
        </div>
        <span class="contentElement__frontNumber">1</span>
        <Icon :side="'back'" />
    </div>
</template>

<script>
import Icon from './Icon'
import Ticker from './Ticker'

export default {

    components: {
        Icon,
        Ticker,
    },

    props: {
        title: {
            type: String,
            required: true,
        },

        features: {
            type: String,
            required: true,
        },

        ctas: {
            type: Array,
            required: true,
        },
    },

}
</script>
